import script from "./CardDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDetail.vue?vue&type=script&setup=true&lang=js"

import "./CardDetail.vue?vue&type=style&index=0&id=1b6bd9aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6bd9aa"]])

export default __exports__